import { render, staticRenderFns } from "./HistoricoEdicoesDlgRec.vue?vue&type=template&id=d7194658"
import script from "./HistoricoEdicoesDlgRec.vue?vue&type=script&lang=js"
export * from "./HistoricoEdicoesDlgRec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports